export default "__VITE_ASSET__Cx7dI6dR__"